<template>
  <el-tabs :value="recordAuth ? 'first' : 'second'" type="card" @tab-click="tabChange">
    <el-tab-pane v-if="recordAuth" label="ESOP文件管理" name="first">
      <esop-list ref="record"/>
    </el-tab-pane>
    <el-tab-pane v-if="treeTypeAuth" label="ESOP文件类型" name="second">
      <vm-tree-type
          ref="tree"
          :category="2"
          :add-auth-index="336"
          :edit-auth-index="336"
          :del-auth-index="336"
          parent-disable/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

  import VmTreeType from "@/components/treeType/VmTreeType.vue";
  import EsopList from "@/views/information/Esop/EsopList.vue";

  export default {
    name: "EsopTabs",
    components: {EsopList, VmTreeType},
    data() {
      return {
        recordAuth: this.$auth(334),
        treeTypeAuth: this.$auth(335),
      };
    },
    methods: {
      tabChange(tab) {
        if (tab.name === "first") {
          this.$refs.record.getList(1);
        }
        if (tab.name === "second") {
          this.$refs.tree.getData(1);
        }
      },
    },
  };
</script>

<style scoped>

</style>
